var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg57(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    width: "48px",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M36.85,9.86c-0.31-0.25-0.52-0.65-0.56-1.1l-0.38-3.73c-0.17-1.61-1.29-2.88-2.73-3.09l-0.79-0.11 c-3.92-0.55-7.91-0.87-11.86-0.93l-0.85-0.01c-1.44,0-2.73,1.08-3.13,2.62l-0.96,3.62c-0.11,0.44-0.38,0.8-0.74,1 c-0.78,0.44-1.31,1.31-1.38,2.27l-0.59,7.55c-0.02,0.26,0.05,0.51,0.2,0.71c0.17,0.22,0.42,0.36,0.69,0.39l0.09,0.01l-0.15,1.88 c-0.08,0.98,0.59,1.83,1.49,1.9l1.1,0.09c0.9,0.07,1.69-0.68,1.76-1.64l0.15-1.88l13.6,1.07l-0.15,1.88 c-0.04,0.46,0.09,0.9,0.35,1.26c0.28,0.37,0.69,0.61,1.13,0.64l1.1,0.09c0.04,0,0.08,0,0.12,0c0.85,0,1.57-0.72,1.64-1.65 l0.15-1.88l0.16,0.01c0.51,0,0.94-0.42,0.98-0.95l0.59-7.55C37.95,11.36,37.57,10.42,36.85,9.86z M33.29,8.83L18.52,7.67 c0.01,0,0.01-0.01,0.01-0.03l0.85-3.25c0.13-0.53,0.53-0.9,0.97-0.9l11.73,0.92c0.46,0.04,0.83,0.48,0.88,1.05L33.29,8.83z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.85,25.54c0.29-0.29,0.42-0.7,0.33-1.1c-0.09-0.4-0.37-0.73-0.76-0.86l-1.16-0.42 c-0.42-0.15-0.91-0.05-1.23,0.26l-1.89,1.84c-2.07,2.01-2.29,5.23-0.51,7.5l0.61,0.78c1.83,2.34,1.94,5.56,0.25,8.04l-1.44,2.33 c-0.23,0.37-0.24,0.83-0.03,1.2c0.21,0.38,0.61,0.61,1.04,0.61h1.21c0.39,0,0.76-0.19,0.98-0.52l1.14-1.68 c2.54-3.72,2.38-8.61-0.4-12.16l-0.61-0.78c-0.67-0.85-0.59-2.07,0.2-2.83L16.85,25.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M32.37,32.09c-0.67-0.86-0.59-2.07,0.2-2.83l2.27-2.23c0.29-0.29,0.42-0.7,0.33-1.1 c-0.09-0.4-0.37-0.73-0.76-0.86l-1.16-0.42c-0.42-0.15-0.91-0.05-1.23,0.26l-1.89,1.84c-2.07,2.01-2.29,5.23-0.51,7.5l0.61,0.78 c1.83,2.34,1.94,5.56,0.25,8.04l-1.44,2.33c-0.23,0.37-0.24,0.83-0.03,1.2c0.21,0.38,0.61,0.61,1.04,0.61h1.21 c0.39,0,0.76-0.19,0.98-0.52l1.14-1.68c2.54-3.72,2.38-8.61-0.4-12.16L32.37,32.09z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg57);
export default __webpack_public_path__ + "static/media/57.bb3a28dddfd6dd9df200003f11ac6614.svg";
export { ForwardRef as ReactComponent };